import {
  IMPORT_SALARY_START,
  IMPORT_SALARY_PROGRESS,
  IMPORT_SALARY_SUCCESS,
  IMPORT_SALARY_FAILED,
  EXPORT_SALARY_START,
  EXPORT_SALARY_SUCCESS,
  EXPORT_SALARY_FAILED
} from '../actionTypes/actionTypes'
import {
  FETCH_COMPANY_OPTIONS_START,
  FETCH_COMPANY_OPTIONS_SUCCESS,
  FETCH_COMPANY_OPTIONS_FAILED,
  FETCH_EMPLOYEE_LEVEL_OPTIONS_START,
  FETCH_EMPLOYEE_LEVEL_OPTIONS_SUCCESS,
  FETCH_EMPLOYEE_LEVEL_OPTIONS_FAILED,
  FETCH_ORGANIZATION_OPTIONS_START,
  FETCH_ORGANIZATION_OPTIONS_SUCCESS,
  FETCH_ORGANIZATION_OPTIONS_FAILED
} from '../../actions/actionTypes'

const initialState = {
  exportSuccess: false,
  uploadFileProgress: 0,
  loadingStates: [],

  companies: [],
  empLevels: [],
  orgs: []
}

const importSalaryStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'import']
  }
}

const importSalarySuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'import')
  }
}

const importSalaryProgress = (state, { progress = 0 }) => {
  return { ...state, uploadFileProgress: progress }
}

const importSalaryFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'import')
  }
}

const exportSalaryStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'export'],
    exportSuccess: false
  }
}

const exportSalarySuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'export'),
    exportSuccess: true
  }
}

const exportSalaryFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'export'),
    exportSuccess: false
  }
}

const fetchCompanyOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'company_id']
  }
}

const fetchCompanyOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    companies: data
  }
}

const fetchCompanyOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id')
  }
}

const fetchEmpLevelOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'level_id']
  }
}

const fetchEmpLevelOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_id'),
    empLevels: data
  }
}

const fetchEmpLevelOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_id')
  }
}

const fetchOrgOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'org_id']
  }
}

const fetchOrgOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    orgs: data
  }
}

const fetchOrgOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id')
  }
}

const reducer = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case IMPORT_SALARY_START:
      return importSalaryStart(state, payload)
    case IMPORT_SALARY_PROGRESS:
      return importSalaryProgress(state, payload)
    case IMPORT_SALARY_SUCCESS:
      return importSalarySuccess(state, payload)
    case IMPORT_SALARY_FAILED:
      return importSalaryFailed(state, payload)

    case EXPORT_SALARY_START:
      return exportSalaryStart(state, payload)
    case EXPORT_SALARY_SUCCESS:
      return exportSalarySuccess(state, payload)
    case EXPORT_SALARY_FAILED:
      return exportSalaryFailed(state, payload)

    case FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyOptionsStart(state, payload)
    case FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanyOptionsSuccess(state, payload)
    case FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyOptionsFailed(state, payload)

    case FETCH_EMPLOYEE_LEVEL_OPTIONS_START:
      return fetchEmpLevelOptionsStart(state, payload)
    case FETCH_EMPLOYEE_LEVEL_OPTIONS_SUCCESS:
      return fetchEmpLevelOptionsSuccess(state, payload)
    case FETCH_EMPLOYEE_LEVEL_OPTIONS_FAILED:
      return fetchEmpLevelOptionsFailed(state, payload)

    case FETCH_ORGANIZATION_OPTIONS_START:
      return fetchOrgOptionsStart(state, payload)
    case FETCH_ORGANIZATION_OPTIONS_SUCCESS:
      return fetchOrgOptionsSuccess(state, payload)
    case FETCH_ORGANIZATION_OPTIONS_FAILED:
      return fetchOrgOptionsFailed(state, payload)

    default:
      return state
  }
}

export default reducer
